import React from "react";
import { interpolate, useCurrentFrame } from "remotion";

export const AuroraBackground: React.FC = () => {
  const frame = useCurrentFrame();

  // Wave 1: slow vertical drift - deep forest green gradient
  const wave1TranslateY = interpolate(frame, [0, 300], [0, -30], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // Wave 2: slow opacity pulse using frame modulo for looping
  const wave2Opacity = interpolate(frame % 120, [0, 60, 120], [0.4, 0.8, 0.4], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // Bokeh orb drift data: [x%, y%, size, hue, driftSpeed, phaseOffset]
  const bokehOrbs = [
    {
      x: 15,
      y: 80,
      size: 80,
      color: "rgba(80,250,123,0.18)",
      driftSpeed: 0.04,
      phase: 0,
    },
    {
      x: 75,
      y: 65,
      size: 55,
      color: "rgba(189,147,249,0.15)",
      driftSpeed: 0.03,
      phase: 30,
    },
    {
      x: 40,
      y: 90,
      size: 100,
      color: "rgba(139,233,253,0.12)",
      driftSpeed: 0.025,
      phase: 60,
    },
    {
      x: 88,
      y: 40,
      size: 65,
      color: "rgba(80,250,123,0.14)",
      driftSpeed: 0.035,
      phase: 90,
    },
    {
      x: 25,
      y: 30,
      size: 45,
      color: "rgba(189,147,249,0.18)",
      driftSpeed: 0.045,
      phase: 15,
    },
    {
      x: 60,
      y: 15,
      size: 72,
      color: "rgba(139,233,253,0.13)",
      driftSpeed: 0.028,
      phase: 45,
    },
  ];

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#0d1f1a",
        overflow: "hidden",
        zIndex: 0,
      }}
    >
      {/* Wave 1: deep forest drift layer */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "120%",
          background:
            "linear-gradient(180deg, #0d1f1a 0%, #1a6b4a 40%, #0d1f1a 100%)",
          transform: `translateY(${wave1TranslateY}px)`,
          zIndex: 1,
        }}
      />

      {/* Wave 2: aurora violet-blue shimmer overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(135deg, rgba(189,147,249,0.15) 0%, rgba(139,233,253,0.1) 50%, transparent 100%)",
          opacity: wave2Opacity,
          zIndex: 2,
        }}
      />

      {/* Wave 3: bioluminescent green radial core glow */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(ellipse at 50% 30%, rgba(80,250,123,0.12) 0%, transparent 70%)",
          zIndex: 3,
        }}
      />

      {/* Bokeh orbs — slow upward drift animation */}
      {bokehOrbs.map((orb, i) => {
        const driftY = interpolate(
          (frame + orb.phase) % 400,
          [0, 400],
          [0, -120],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" },
        );
        const orbOpacity = interpolate(
          (frame + orb.phase) % 400,
          [0, 80, 320, 400],
          [0, 0.85, 0.85, 0],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" },
        );
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: `${orb.x}%`,
              top: `${orb.y}%`,
              width: orb.size,
              height: orb.size,
              borderRadius: "50%",
              background: `radial-gradient(circle, ${orb.color} 0%, transparent 70%)`,
              filter: "blur(18px)",
              transform: `translate(-50%, -50%) translateY(${driftY}px)`,
              opacity: orbOpacity,
              zIndex: 4,
            }}
          />
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
